/*
 * @Author: tkp
 * @Date: 2021-11-20 16:40:50
 */
import http from './http'

//获取oss路径url获取密钥
export function generatePresignedUrl(params) {
    return http.post(`/amaos/file/generatePresignedUrl`, params)
}
//沙漠鲸官网-学员新增
export function traineeAdd(params) {
    return http.post(`/custom/smj-site/trainee/add`, params)
}
//管理员登录图片校验
export function getVerifyImageAdmin2(params) {
    return http.get(`/authority/verify/get_text_verify_image`)
}


// WEBPACK FOOTER //
// ./src/utils/api.js